<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    src?: string
    alt?: string
    externalImage?: boolean
    className?: string
}>()

const emit = defineEmits(['loaded'])

const source = computed(() => {
    if (!props.src) return '/images/default-image.png'
    if (props.externalImage) return props.src

    const fitIn = '0x2400'

    return `${import.meta.env.VITE_CDN_URL}/${fitIn}/${props.src}`
})
</script>

<template>
    <img :src="source" :alt="alt" :class="className" @load="emit('loaded')" />
</template>
